import React, { Suspense, lazy } from 'react';
import { useStore } from './store/useStore';
import styles from './FinStatisticV2.module.css';

// Главный экран
import MobileDashboard from './screens/MobileDashboard';

// Ленивая загрузка модалок
const FiltersModal = lazy(() => import('./modals/FiltersModal'));
const RoutesSelectionModal = lazy(() => import('./modals/RoutesSelectionModal'));
const ReportModal = lazy(() => import('./modals/ReportModal'));
const SettingsModal = lazy(() => import('./modals/SettingsModal'));

export default function FinStatisticV2() {
  const { modals } = useStore();

  return (
    <div className={styles.pageContainer}>
      {/* Основной контент страницы */}
      <MobileDashboard />

      {/* Модальные окна */}
      <Suspense fallback={null}>
        {modals.isFiltersOpen && <FiltersModal />}
        {modals.isRoutesSelectorOpen && <RoutesSelectionModal />}
        {modals.isReportOpen && <ReportModal />}
        {modals.isSettingsOpen && <SettingsModal />}
      </Suspense>
    </div>
  );
}
